export default __webpack_public_path__ + "static/media/login-icon.9ef77e3d.svg";